export const UPDATE_HOME_DETAIL_INFORMATION = "UPDATE_HOME_DETAIL_INFORMATION"
export const HOME_DETAIL_LOADING = "HOME_DETAIL_LOADING"